import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  removeFromCart,
  increaseQuantity,
  decreaseQuantity,
} from "../store/action/cartAction";
import { proceedToCheckout } from "../store/action/checkAction";
import { storeRedirectUrl } from "../store/action/authAction";
import { Link } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import { CiTrash } from "react-icons/ci";
import { FaMinus, FaPlus } from "react-icons/fa6";
import PostHog from "posthog-js";
import "./cart.css";

const Cart = ({ closeCart, toggleLogin, closeCartRef }) => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.cartItems);

  const totalAmount = cartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  const handleCheckout = () => {
    // Track checkout event with PostHog
    PostHog.capture("Checkout Initiated", {
      property: "Total Amount",
      value: totalAmount,
    });
    dispatch(proceedToCheckout(cartItems, totalAmount));
    closeCart();
  };

  const handleSocialLogin = () => {
    // Store the path only, not full URL
    const currentPath = window.location.pathname + window.location.search;
    dispatch(storeRedirectUrl(currentPath));
    toggleLogin(true);
    closeCart();
    console.log("this is my redirect url", currentPath);
  };

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  return (
    <div className="cart" ref={closeCartRef}>
      <div className="cart-wrapper">
        {/* Header */}
        <div className="cart-header">
          <h2>Shopping Cart</h2>
          <button className="close-button" onClick={closeCart}>
            <IoClose size="25" />
          </button>
        </div>

        {/* Cart Items */}
        {/* Cart Items */}
        <div className="cart-items">
          {cartItems.length === 0 ? (
            <p>Your cart is empty.</p>
          ) : (
            cartItems.map((item) => (
              <div className="cart-item" key={item.id}>
                <div className="item-image">
                  <img
                    src={
                      Array.isArray(item.itemPhotos)
                        ? item.itemPhotos[0] || "/placeholder-image.jpg"
                        : item.itemPhotos || "/placeholder-image.jpg"
                    }
                    alt={item.item_name || "Unnamed Item"}
                  />
                </div>

                <div className="item-details">
                  <h3>{item.item_name || "Unnamed Item"}</h3>
                  <p className="price">
                    K {item.price?.toLocaleString() ?? "0"}
                  </p>

                  <div className="quantity-controls">
                    <button
                      onClick={() => dispatch(decreaseQuantity(item.id))}
                      className="quantity-button"
                      disabled={item.quantity <= 1}
                    >
                      <FaMinus />
                    </button>
                    <span className="quantity">{item.quantity}</span>
                    <button
                      onClick={() => dispatch(increaseQuantity(item.id))}
                      className="quantity-button"
                    >
                      <FaPlus />
                    </button>
                  </div>
                </div>

                <button
                  className="remove-button"
                  onClick={() => dispatch(removeFromCart(item.id))}
                >
                  <CiTrash />
                </button>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        <div className="cart-footer">
          <div className="total">
            <span>Total</span>
            <span className="total-amount">
              K{" "}
              {cartItems
                .reduce((total, item) => total + item.price * item.quantity, 0)
                .toLocaleString()}
            </span>
          </div>
          {!isAuthenticated ? (
            <button className="checkout-button" onClick={handleSocialLogin}>
              Login to Checkout
            </button>
          ) : (
            <Link to="/CheckOut">
              <button className="checkout-button" onClick={handleCheckout}>
                Checkout
              </button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Cart;
